export const usesMobileRendering = (
  client = typeof navigator === 'undefined' ? {} : navigator
) =>
  /iPhone|iPad|iPod/.test(client.userAgent || '') ||
  (client.platform === 'MacIntel' && client.maxTouchPoints > 1);

export const shouldPauseBoardRendering = (mount, mobile) => {
  if (!mobile) return false;
  const dialogs = mount.ownerDocument.querySelectorAll('[aria-modal="true"]');
  const dialog = dialogs[dialogs.length - 1];
  return !!dialog && !dialog.contains(mount);
};
